<template>
  <section class="panel">
    <div class="panel-header">
      <div>
        <h2>{{ title }}</h2>
        <p>{{ subtitle }}</p>
      </div>
    </div>
    <div class="movement-grid">
      <div>
        <h3>Growing</h3>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Now</th>
              <th>Prev</th>
              <th>Delta</th>
              <th>Share</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in growing" :key="row.id">
              <td>{{ row.title }}</td>
              <td>{{ formatNumber(row.current) }}</td>
              <td>{{ formatNumber(row.previous) }}</td>
              <td class="positive">+{{ formatNumber(row.delta) }}</td>
              <td :class="row.shareDelta >= 0 ? 'positive' : 'negative'">{{ formatPercent(row.shareDelta) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h3>Shrinking</h3>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Now</th>
              <th>Prev</th>
              <th>Delta</th>
              <th>Share</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in shrinking" :key="row.id">
              <td>{{ row.title }}</td>
              <td>{{ formatNumber(row.current) }}</td>
              <td>{{ formatNumber(row.previous) }}</td>
              <td class="negative">{{ formatNumber(row.delta) }}</td>
              <td :class="row.shareDelta >= 0 ? 'positive' : 'negative'">{{ formatPercent(row.shareDelta) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: 'Last 12 months vs prior 12 months.' },
  rows: { type: Array, default: () => [] }
});

const growing = computed(() => props.rows.filter((row) => row.delta > 0).slice(0, 8));
const shrinking = computed(() => props.rows.filter((row) => row.delta < 0).sort((a, b) => a.delta - b.delta).slice(0, 8));

function formatNumber(value) {
  return new Intl.NumberFormat('en').format(value || 0);
}

function formatPercent(value) {
  const sign = value > 0 ? '+' : '';
  return `${sign}${(value * 100).toFixed(1)}pp`;
}
</script>
